import * as z from "zod";

const wistiaEventFields = {
  source: z.enum(["manual", "wistia"]).optional(),
  wistiaMediaId: z.string().optional(),
  wistiaWebinarId: z.string().optional(),
  wistiaScheduledFor: z.string().optional(),
  wistiaEventDuration: z.number().nullable().optional(),
  wistiaMediaUrl: z.string().url().optional(),
  wistiaThumbnailUrl: z.string().url().optional(),
  wistiaDuration: z.number().nullable().optional(),
  wistiaSyncedAt: z.any().optional(),
};

export const createPostSchema = z.object({
  title: z.string().trim().min(1, "Post Title is required"),
  status: z.enum(["active", "archived"], {
    required_error: "Status selection is required",
  }),
  featured: z.enum(["featured", "non-featured"], {
    required_error: "Featured selection is required",
  }),
  description: z.string().trim().min(1, "Description is required"),
  images: z.array(z.any()).max(5, "Maximum 5 images allowed").optional(),
  ...wistiaEventFields,
});


export const createEventSchema = z.object({
  title: z.string().trim().min(1, "Event Title is required"),

  status: z.enum(["active", "archived"], {
    required_error: "Status selection is required",
  }),

  eventStartDate:z
    .preprocess(
      (val) => (val === "" ? undefined : val),
      z.date()
    ),

  eventEndDate: z
    .preprocess(
      (val) => (val === "" || val === null ? undefined : val),
      z.date().optional()
    ),

  eventStartTime: z.string().optional(),

  eventUrl: z
    .string()
    .min(1, "Event URL is Required")
    .url("Invalid URL format"),

  eventLocation: z.string().trim().min(1, "Event Location is required"),

  featured: z.enum(["featured", "non-featured"], {
    required_error: "Featured selection is required",
  }),

  description: z.string().trim().min(1, "Description is required"),

  images: z.array(z.any()).max(5, "Maximum 5 images allowed").optional(),
  ...wistiaEventFields,
});
